import React, { useState, useEffect } from "react";
import axios from "axios";

import Button from "react-bootstrap/Button";
import "./ReportGen.css";
import { SubTopic } from "../pages/SubTopic";
import Spinner from "react-bootstrap/Spinner";
import Moment from "react-moment";
import logout from "../images/logout-svgrepo-com.svg";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import { useHistory } from "react-router-dom";

export const ProfileView = () => {
  const history = useHistory();

  const [profile, setProfile] = useState(
    JSON.parse(localStorage.getItem("g_profile"))
  );
  function logut() {
    googleLogout();
    localStorage.setItem("g_profile", null);
    history.push("/logout");
  }
  return (
    <div className="">
      {profile && profile.picture ? (
        <div className="profileBar">
          <img src={profile.picture} alt="" className="profilePhoto" />
          {"      "}
          <button onClick={logut} className="logoutButton" title="Logout">
            <img className="logoutImage" src={logout} alt="" />
          </button>
          <br></br>
        </div>
      ) : (
        <div className="profileBar"></div>
      )}
    </div>
  );
};

export default ProfileView;
